<template>
  <div style="height:50%;justify-content: center;flex-wrap: wrap;" class="flex">
    <div class="baseData">
      <div v-for="(item, index) in baseData" :key="index" class="baseDataList">
        <div class="baseData_name">
          <img v-lazy="item.url" style="height:100%" />
        </div>
        <div style="text-align:center" class="baseData_fName">
          <i class="baseData_num">{{ item.num }}</i
          ><span class="baseData_unit">{{ item.unit }}</span>
          <p>{{ item.name }}</p>
        </div>
      </div>
    </div>
    <div class="mainContent flex">
      <div class="swiper" v-if="imgList.length > 0">
        <swiper :options="swiperOption" class="imgcase">
          <swiper-slide v-for="(item, index) in imgList" :key="index">
            <img
              v-lazy="$config.imgIp + item.logo"
              class="pic"
              @click="previewClick(imgList, index)"
            />
            <p class="name">{{ item.name }}</p>
          </swiper-slide>
        </swiper>
      </div>
      <div class="swiper-button-next" v-if="imgList.length > 2"></div>
      <div class="swiper-button-prev" v-if="imgList.length > 2"></div>
    </div>
    <div ref="chart" class="chart"></div>
    <div class="line"></div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import { mapGetters } from "vuex";
import { loadChart } from "./chart/dmData";
import { getScreenV2GetQYZB, findOrgCompanyBrand } from "@/api/base";
export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  computed: { ...mapGetters(["graphic"]) },
  watch: {
    graphic() {
      this.getData();
    },
  },
  data() {
    return {
      swiperOption: {
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        debugger: true,
        autoplayDisableOnInteraction: false, // 用户操作swiper之后，是否禁止
        loop: false,
        autoplay: 5000,
        spaceBetween: 26,
        slidesPerView: 6, //设置slider容器能够同时显示的slides数量(carousel模式)。可以设置为数字（可为小数，小数不可loop），或者 'auto'则自动根据slides的宽度来设定数量。loop模式下如果设置为'auto'还需要设置另外一个参数loopedSlides。
        centeredSlides: false, //<span style="color:rgb(68,68,68);font-family:'microsoft yahei';font-size:13px;">设定为true时，活动块会居中，而不是默认状态下的居左。</span>
        prevButton: ".swiper-button-prev", //上一张
        nextButton: ".swiper-button-next", //下一张
        notNextTick: true,
        pagination: ".swiper-pagination",
        speed: 300,
        stopOnLastSlide: false,
        disableOnInteraction: false,
      },
      baseData: [
        {
          name: "种植基地",
          num: 320,
          unit: "(个)",
          url: require("images/index/home/icon_yzjd.png"),
        },
        {
          name: "种植面积",
          num: 1126,
          unit: "(亩)",
          url: require("images/index/home/icon_yzmj.png"),
        },
        {
          name: "企业品牌",
          num: 16,
          unit: "(个)",
          url: require("images/index/home/icon_ppgl.png"),
        },
        {
          name: "年供产量",
          num: 81,
          unit: "(吨)",
          url: require("images/index/home/icon_nccl.png"),
        },
      ],
      imgList: [],
    };
  },
  mounted() {
    this.getData();
    this.getChart();
  },
  methods: {
    getData() {
      getScreenV2GetQYZB({ orgId: this.graphic.id }).then((res) => {
        let datas = res.data;
        this.baseData[0].num = datas.jdsl;
        this.baseData[1].num = datas.zzmj;
        this.baseData[2].num = datas.qypp;
        this.baseData[3].num = datas.ncl;
      });
      findOrgCompanyBrand({ companyId: this.graphic.id }).then((res) => {
        if (res.code === 200) {
          this.imgList = res.data;
          if (this.imgList.length <= 2) {
            this.swiperOption.loop = false;
          }
        }
      });
    },
    getChart() {
      let datas = ["131", "231", "267", "341", "286", "387", "321"];
      let units = "万元";
      let years = ["2015", "2016", "2017", "2018", "2019", "2020"];
      this.chart = this.$echarts.init(this.$refs.chart);
      loadChart(this.chart, datas, years, units);
      window.addEventListener("resize", () => {
        this.chart.resize();
      });
    },
    handleClose() {
      this.$store.dispatch("drawer/setDrawerComponent", "homeDrawer");
    },
    //图片预览
    previewClick(item, index) {
      this.$bus.$emit("previewImg", item, index);
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'
.closeBtn
  padding 0
  background transparent
  border 0
  color #fff
  font-size 22px
  z-index 9
  position absolute
  right 0
  top 1px
  &:hover
    background transparent
    color #fff
.baseData
  display flex
  flex-wrap nowrap
  align-items flex-start
  justify-content space-between
  width 90%
  height 23%
.baseDataList
  width 21%
  background url('~images/index/home/gs_bar.png') no-repeat center
  background-size 100% 100%
  height 100%
.baseDataList:last-child
  border none
.baseData_num
  font-family 'electronicFont'
  font-size 24px
  color rgb(1, 225, 251)
.baseData_fName
  text-align center
  border-radius 45%
  height 50%
  font-size 0.06rem
.baseData_name
  color #fff
  font-size 13px
  width -webkit-max-content
  width -moz-max-content
  margin 0 auto 5px
  text-align center
  width 100%
  height calc(50% - 5px)
.baseData_unit
  font-size 13px
  vertical-align bottom
  color rgb(1, 225, 251)
.mainContent
  height calc(35% - 0px)
  position relative
  width 93%
.imgcase
  width calc(33% - 23px)
  padding 10px 14px 5px 14px
  overflow initial
  margin 0
  height calc(100% - 20px)
.name
  text-align center
  color #fff
  margin-top 4px
  font-size 0.06rem
.pic
  height calc(100% - 32px)
  border 6px solid rgba(10, 53, 104, 0.8)
.swiper
  width 100%
  overflow hidden
  height 100%
.swiper-button-prev
  top 50%
  left -7px
  height 22px
.swiper-button-next
  top 50%
  right -7px
  height 22px
.swiper-slide
  cursor pointer
  display flex
  align-content center
  justify-content center
  flex-direction column
.line
  height 1px
  background linear-gradient(to right, transparent, #2bb7b5, transparent)
.chart
  height 42%
  width 100%
@media (max-width 1280px)
  .content
    height calc(100% - 25px)
  .closeDraw
    top -20px
    .el-button
      font-size 15px
  .baseData_num
    font-size 0.11rem
  .baseData_name
    font-size 0.08rem
  .baseData_unit
    font-size 0.09rem
  .baseData_fName
    font-size 0.08rem
  .name
    font-size 0.08rem
  .pic
    height calc(100% - 26px)
    border 3px solid rgba(10, 53, 104, 0.8)
  .swiper-button-prev, .swiper-button-next
    width 25px !important
    height 15px !important
    background-size 20px 30px !important
    top 60% !important
  .swiper-button-prev
    left -7px
  .swiper-button-next
    right -7px
</style>
